import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionManagerService } from '../pages/admin/permissions/services/permissions-manager.service';
import { PermissionType } from '../pages/admin/permissions/permission-type.enum';

@Directive({
  selector: '[appIsGranted]',
})
export class IsGrantedDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionManagerS: PermissionManagerService
  ) {}

  @Input() set appIsGranted(permission: Array<string>) {
    this.isGranted(
      permission[0] as string,
      permission[1] as string,
      permission[2] as PermissionType
    );
  }

  private isGranted(
    resource: string,
    item: string,
    permissionType: PermissionType
  ) {
    if (this.permissionManagerS.isGranted(resource, item, permissionType)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
